<template>
  <div id="system-publish-key-relationship">
    <div class="relative ipub-list-tab line-h-40">
      <a @click="changeStatus('')"
         :class="['ipub-list-tab--status',params.released===''?'active':'']">All</a>
      <a @click="changeStatus(true)"
         :class="['ipub-list-tab--status mar-l-40',params.released===true?'active':'']">Published</a>
      <a @click="changeStatus(false)"
         :class="['ipub-list-tab--status mar-l-40',params.released===false?'active':'']">Draft</a>
      <div class="right-option">
        <ipub-button type="primary"
                     icon="iconAdd"
                     @click="add">
          Add Partner
        </ipub-button>
      </div>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  :pagination="false"
                  draggable
                  @drag="setSort"
                  :dataSource="dataSource">
        <template v-slot:img="{text}">
          <img class="ipub-table-slot-img"
               :src="`${domain}/${text}`"
               alt="">
        </template>
        <template v-slot:time="{record}">
          {{ (record.updateTime||record.createTime)?$moment(record.updateTime||record.createTime).format('HH : mm DD / MM / YYYY'): '- -' }}
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.COLLABORATION.EDIT')"
                        class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <template>
            <ipub-tooltip v-if="record.released"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.COLLABORATION.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Add ref="key-relationship-add"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
